import { render, staticRenderFns } from "./_form.chats.page.vue?vue&type=template&id=112adfdc&scoped=true&"
import script from "./_form.chats.page.vue?vue&type=script&lang=js&"
export * from "./_form.chats.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.chats.page.vue?vue&type=style&index=0&id=112adfdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112adfdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VForm,VIcon})
